import { showError } from "../../../../util/ShowStatus";

export const validateEnvForm = (
  formValues: any,
  fileValues: any,
  firstRef: any,
  secondRef: any,
  additionalMemberRefs: any,
  isPermitSpaceFormAttached: boolean,
  envEntrantTopmans: any,
  toast: any
) => {
  if (!formValues?.projectKeyName || formValues?.projectKeyName.trim() === "") {
    showError("Project Value is required", toast);
    return false;
  }
  if (!formValues?.date) {
    showError("Date is required", toast);
    return false;
  }
  if (!formValues?.location || formValues?.location.trim() === "") {
    showError("Location is required", toast);
    return false;
  }
  if (!formValues?.vehicleRegistration) {
    showError("Vehicle registration is required", toast);
    return false;
  }

  if (!formValues.teamMember1.userID) {
    showError("Team Member 1 is required", toast);
    return false;
  }
  if (
    !fileValues.find((photo: any) => {
      return photo.userID === formValues.teamMember1.userID;
    })
  ) {
    showError("Photo of Team Member 1 is required", toast);
    return false;
  }

  if (!formValues.teamMember2.userID) {
    showError("Team Member 2 is required", toast);
    return false;
  }
  if (
    !fileValues.find((photo: any) => {
      return photo.userID === formValues.teamMember2.userID;
    })
  ) {
    showError("Photo of Team Member 2 is required", toast);
    return false;
  }

  if (formValues.additionalTeamMembers.length > 0) {
    for (let i = 0; i < formValues.additionalTeamMembers.length; i++) {
      const member = formValues.additionalTeamMembers[i];
      const photoExists = fileValues.some(
        (photo: any) => photo.userID === member.userID
      );
      if (!photoExists) {
        showError(
          `Photo of Additional Team Member ${member.displayName} is required`,
          toast
        );
        return false;
      }
    }
  }

  if (
    !fileValues?.find(
      (photo: any) => photo.photoKey && photo.photoKey === "van_photo-1"
    ) ||
    !fileValues?.find(
      (photo: any) => photo.photoKey && photo.photoKey === "van_photo-2"
    )
  ) {
    showError("Both photos of Van are required", toast);
    return false;
  }

  if (!formValues.keyPlantDetails || formValues.keyPlantDetails.length === 0) {
    showError("Key Plant Details are required", toast);
    return false;
  }
  if (!formValues.activity || formValues.activity.length === 0) {
    showError("Activity is required", toast);
    return false;
  }
  if (formValues.emergencyDetails.isFirstAiderAvailable === null) {
    showError("First Aider availability is required", toast);
    return false;
  }
  if (formValues.emergencyDetails.isFirstAidKitAvailable === null) {
    showError("First Aid Kit availability is required", toast);
    return false;
  }
  if (
    !formValues.emergencyDetails.aAndE &&
    (!formValues.emergencyDetails.others ||
      formValues.emergencyDetails.others.trim() === "")
  ) {
    showError(
      "Please Select closest A&E from dropdown or type in 'Others' Input Box",
      toast
    );
    return false;
  }
  // if (!formValues.emergencyDetails.aAndE) {
  //   showError("Closest A&E detail is required", toast);
  //   return false;
  // }
  if (!formValues.emergencyDetails.emergencyContact) {
    showError("Emergency Contact is required", toast);
    return false;
  }

  // Check checklist values
  const hasInvalidChecklist = formValues.startWorkAssessment.checklist.some(
    (item: any) => item.value === null
  );
  if (hasInvalidChecklist) {
    showError("All checklist items must have a value", toast);
    return false;
  }

  // Check risk elements values
  const hasInvalidRiskElements =
    formValues.startWorkAssessment.riskelements.some(
      (element: any) => element.value === null
    );
  if (hasInvalidRiskElements) {
    showError("All risk elements must have a value", toast);
    return false;
  }

  // Check all risk elements have actions
  const hasEmptyActions = formValues.startWorkAssessment.riskelements.some(
    (element: any) => element.value === true && !element.action
  );
  if (hasEmptyActions) {
    showError("Actions are required for all risk elements", toast);
    return false;
  }

  // Check signatures
  if (firstRef.current?.isEmpty()) {
    showError("Signature of Team Member 1 is required", toast);
    return false;
  }
  if (secondRef.current?.isEmpty()) {
    showError("Signature of Team Member 2 is required", toast);
    return false;
  }

  if (formValues.additionalTeamMembers.length > 0) {
    const hasEmptyAdditionalSignatures = formValues.additionalTeamMembers.some(
      (member: any, index: number) => {
        const ref = additionalMemberRefs[index];
        return ref.current?.isEmpty();
      }
    );
    if (hasEmptyAdditionalSignatures) {
      showError(
        "Signatures for all Additional Team Members are required",
        toast
      );
      return false;
    }
  }

  const confinedSpacePermitChecklistItem =
    formValues?.startWorkAssessment?.checklist.find(
      (item: any) => item.name === "confinedSpaceEntryPermit"
    );

  if (
    confinedSpacePermitChecklistItem?.value === true &&
    !isPermitSpaceFormAttached
  ) {
    // Check that at least one approval and one closure entrant/topman signature exist
    const approvalEntrantTopman =
      envEntrantTopmans.teamMember1.approvalOfPermit ||
      envEntrantTopmans.teamMember2.approvalOfPermit ||
      envEntrantTopmans.additionalMembers.approvalOfPermit.some(
        (et: any) => et === true
      );

    const closureEntrantTopman =
      envEntrantTopmans.teamMember1.permitClosure ||
      envEntrantTopmans.teamMember2.permitClosure ||
      envEntrantTopmans.additionalMembers.permitClosure.some(
        (et: any) => et === true
      );

    if (!approvalEntrantTopman) {
      showError(
        "Please add Entrant/Topman value for approval signature when Confined Space Entry Permit is selected as Yes.",
        toast
      );
      return false;
    }
    if (!closureEntrantTopman) {
      showError(
        "Please add Entrant/Topman value for closure signature when Confined Space Entry Permit is selected as Yes.",
        toast
      );
      return false;
    }
  }

  // Add your form validation logic here
  return true; // Return true if valid, false otherwise
};

export const validateEquipmentForm = (currentFormValues: any, toast: any) => {
  // Basic validation logic
  if (!currentFormValues?.site || currentFormValues?.site.trim() === "") {
    showError(
      "Site value is required in Pre Use Equipment Checklist Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFormValues?.completedBy?.userID ||
    !currentFormValues?.completedBy?.displayName
  ) {
    showError(
      "Completed By is required in Pre Use Equipment Checklist Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (!currentFormValues?.dateTime) {
    showError(
      "Date and Time is required in Pre Use Equipment Checklist Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const loweringEquipmentUnselected =
    currentFormValues?.loweringEquipment?.some((item: any) => !item.value);
  if (loweringEquipmentUnselected) {
    showError(
      "Please select Yes/No/N/A for all Lowering Equipment items in Pre Use Equipment Checklist Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const surveyEquipmentUnselected = currentFormValues?.surveyEquipment?.some(
    (item: any) => !item.value
  );
  if (surveyEquipmentUnselected) {
    showError(
      "Please select Yes/No/N/A for all Survey Equipment items in Pre Use Equipment Checklist Form",
      toast,
      "",
      8000
    );
    return false;
  }

  // Add your form validation logic here
  return true; // Return true if valid, false otherwise
};

export const validateConfinedSpaceForm = (
  currentFormValues: any,
  currentFileValues: any,
  toast: any
) => {
  if (!currentFormValues?.site || currentFormValues?.site.trim() === "") {
    showError(
      "Site Value is required in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFormValues?.completedBy?.userID ||
    !currentFormValues?.completedBy?.displayName
  ) {
    showError(
      "Completed By is required in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (!currentFormValues?.date) {
    showError(
      "Date is required in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const tripodChecklistUnselected = currentFormValues?.tripodChecklist?.some(
    (item: any) => !item.value
  );
  if (tripodChecklistUnselected) {
    showError(
      "Please select Yes/No/N/A for all Tripod Checklist items in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const winchChecklistUnselected = currentFormValues?.winchChecklist?.some(
    (item: any) => !item.value
  );
  if (winchChecklistUnselected) {
    showError(
      "Please select Yes/No/N/A for all Winch Checklist items in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const safetyHarnessChecklistUnselected =
    currentFormValues?.safetyHarnessChecklist?.some((item: any) => !item.value);
  if (safetyHarnessChecklistUnselected) {
    showError(
      "Please select Yes/No/N/A for all Safety Harness Checklist items in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const connectorsChecklistUnselected =
    currentFormValues?.connectorsChecklist?.some((item: any) => !item.value);
  if (connectorsChecklistUnselected) {
    showError(
      "Please select Yes/No/N/A for all Connectors Checklist items in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const gasMonitorChecklistUnselected =
    currentFormValues?.gasMonitorChecklist?.some((item: any) => !item.value);
  if (gasMonitorChecklistUnselected) {
    showError(
      "Please select Yes/No/N/A for all Gas Monitor Checklist items in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("tripos")
    )
  ) {
    showError(
      "Please upload the Tripos photograph in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("winch")
    )
  ) {
    showError(
      "Please upload the Winch photograph in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("harness")
    )
  ) {
    showError(
      "Please upload the Harness photograph in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("gas_monitors")
    )
  ) {
    showError(
      "Please upload the Gas Monitors photograph in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("connectors")
    )
  ) {
    showError(
      "Please upload the Connectors photograph in Pre Use Confined Space Equipment Form",
      toast,
      "",
      8000
    );
    return false;
  }

  // Add your form validation logic here
  return true; // Return true if valid, false otherwise
};

export const validatePermitForm = (
  currentFormValues: any,
  currentFileValues: any,
  permitApprovalRefs: any,
  permitClosureRefs: any,
  permitSignatureFiles: any,
  envUsers: any,
  toast: any
) => {
  // if (!currentFormValues?.project || currentFormValues?.project.trim() === "") {
  //   showError("Project Value is required", toast);
  //   return false;
  // }
  if (!currentFormValues?.name || currentFormValues?.name.length === 0) {
    showError(
      "Atleast one name is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (!currentFormValues?.site || currentFormValues?.site.trim() === "") {
    showError(
      "Site is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (!currentFormValues?.surveySiteDescription) {
    showError(
      "Description of Survey Site is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (
    currentFormValues?.surveySiteDescription &&
    currentFormValues?.surveySiteDescription === "Other" &&
    (!currentFormValues?.surveySiteDescriptionComment ||
      currentFormValues?.surveySiteDescriptionComment.trim() === "")
  ) {
    showError(
      "Comments are required when survey site description is 'Other' in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (!currentFormValues?.purposeOfEntry) {
    showError(
      "Purpose of Entry is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const preEntryChecksUnselected = currentFormValues?.preEntryChecks?.some(
    (item: any) => !item.value
  );
  if (preEntryChecksUnselected) {
    showError(
      "Please select Yes/No/N/A for all Pre-Entry Checks items in Permit for Confined Space Entry Form.",
      toast
    );
    return false;
  }

  // Check all preEntryChecks have a value
  const preEntryChecksInvalid = currentFormValues?.preEntryChecks?.some(
    (item: any) => !item.value
  );
  if (preEntryChecksInvalid) {
    showError(
      "Please select Yes/No/N/A for all Pre-Entry Checks items in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  // If value is 'yes', check all control measures inside have a value
  const preEntryChecksControlMeasuresInvalid =
    currentFormValues?.preEntryChecks?.some(
      (item: any) =>
        item.value === "yes" &&
        Array.isArray(item.controlMeasure) &&
        item.controlMeasure.some((cm: any) => !cm.value)
    );
  if (preEntryChecksControlMeasuresInvalid) {
    showError(
      "Please select Yes/No/N/A for all Control Measures where Pre-Entry Check is 'Yes' in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const safetyEssentialEquipmentCheckUnselected =
    currentFormValues?.safetyEssentialEquipmentCheck?.some(
      (item: any) => !item.value
    );
  if (safetyEssentialEquipmentCheckUnselected) {
    showError(
      "Please select Yes/No/N/A for all Safety Essential Equipment Check items in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("site_setup-1")
    )
  ) {
    showError(
      "Please upload the Site Setup 1 photograph in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }
  if (
    !currentFileValues.some(
      (file: any) =>
        file.photoKey && file.photoKey.toLowerCase().includes("site_setup-2")
    )
  ) {
    showError(
      "Please upload the Site Setup 2 photograph in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (!currentFormValues?.permitClosureReason) {
    showError(
      "Permit Closure Reason is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (
    currentFormValues?.permitClosureReason &&
    currentFormValues?.permitClosureReason === "Confined Spaces Aborted" &&
    (!currentFormValues?.commentsIfAny ||
      currentFormValues?.commentsIfAny.trim() === "")
  ) {
    showError(
      "Comments are required when permit closure reason is 'Confined Spaces Aborted' in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (!currentFormValues?.permitStartDateAndTime) {
    showError(
      "Permit Start Date and Time is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  if (!currentFormValues?.permitEndDateAndTime) {
    showError(
      "Permit End Date and Time is required in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  // Validate that start time is not greater than end time
  if (
    currentFormValues.permitStartDateAndTime &&
    currentFormValues.permitEndDateAndTime
  ) {
    const permitStartDateAndTime = new Date(
      currentFormValues.permitStartDateAndTime
    ).getTime();
    const permitEndDateAndTime = new Date(
      currentFormValues.permitEndDateAndTime
    ).getTime();

    if (permitStartDateAndTime > permitEndDateAndTime) {
      showError(
        "Permit End Time must not be earlier than Permit Start Time in Permit for Confined Space Entry Form",
        toast,
        "",
        8000
      );
      return false;
    }
  }

  // Check that every userID in currentFormValues.name is also in permitSignatureFiles.permitApproval
  // Find users present in both allEnvUsers and permitFileValues
  const onlyPermitUser = currentFormValues.name.filter((user: any) => {
    return !envUsers.some((envUser: any) => envUser.userID === user.userID);
  });

  const missingApprovalSignatures = onlyPermitUser.filter(
    (user: any) =>
      !permitSignatureFiles.approvalOfPermit.some(
        (sig: any) => sig.userID === user.userID
      )
  );

  if (missingApprovalSignatures.length > 0) {
    showError(
      "All users must have an approval signature in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  const missingClosureSignatures = onlyPermitUser.filter(
    (user: any) =>
      !permitSignatureFiles.permitClosure.some(
        (sig: any) => sig.userID === user.userID
      )
  );

  if (missingClosureSignatures.length > 0) {
    showError(
      "All users must have a closure signature in Permit for Confined Space Entry Form",
      toast,
      "",
      8000
    );
    return false;
  }

  for (let i = 0; i < currentFormValues.name.length; i++) {
    const user = currentFormValues.name[i];
    const entrantTopmanApproval =
      currentFormValues.entrantTopmans?.approvalOfPermit?.find(
        (et: any) => et.userID?.toString() === user.userID?.toString()
      );
    const entrantTopmanClosure =
      currentFormValues.entrantTopmans?.permitClosure?.find(
        (et: any) => et.userID?.toString() === user.userID?.toString()
      );
    if (!entrantTopmanApproval || !entrantTopmanApproval.value) {
      showError(
        `Entrant/Topman is required for approval signature of ${
          user.displayName || "User " + (i + 1)
        }`,
        toast
      );
      return false;
    }
    if (!entrantTopmanClosure || !entrantTopmanClosure.value) {
      showError(
        `Entrant/Topman is required for closure signature of ${
          user.displayName || "User " + (i + 1)
        }`,
        toast
      );
      return false;
    }
  }

  // Add your form validation logic here
  return true; // Return true if valid, false otherwise
};
